import {NeoButton} from "@/components/forms";
import {NeoError, NeoSuccess} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {driversService} from "@/service/drivers.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Resolver, useForm} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import Select from "react-select";
import * as yup from "yup";
import {AssignedVehicleView} from "../view/assignedVehicle";
export const VehicleFormv2: React.FC<any> = function ({
  driverVehicleEditdata,
  getDriverData
}) {
  const [loading, setLoading] = useState(false);
  const {vehicles} = useNeoContext();
  const validationSchema = yup.object().shape({
    trackerId: yup.number().required("Vehicle is required")
  });
  const [succssMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [vehiceDetails, setVehicleDetails] = useState<any>({fields: []});
  const {
    control,
    setValue,
    register,
    handleSubmit,
    setError,
    clearErrors,
    reset,
    formState: {isSubmitting, isValid, errors}
  } = useForm<any>({
    mode: "onChange",
    resolver: yupResolver(validationSchema) as Resolver<any>
  });
  useEffect(() => {
    // if (driverVehicleEditdata) {
    //   reset(driverVehicleEditdata); // works correctly even in modal
    // }{ label: "Vehicle", value: "NA", type: "text", key: "trackerName", isVisible: false }
    if (driverVehicleEditdata?.trackerName) {
      setVehicleDetails({
        fields: [
          {
            label: "Vehicle",
            value: driverVehicleEditdata?.trackerName
              ? driverVehicleEditdata?.trackerName
              : "NA",
            type: "text",
            key: "trackerName",
            isVisible: true
          },
          {
            label: "trackerId",
            value: driverVehicleEditdata?.trackerId,
            type: "text",
            key: "trackerId",
            isVisible: false
          }
        ]
      });
    } else {
      setVehicleDetails({
        fields: []
      });
    }
  }, [driverVehicleEditdata.trackerName]);
  const onSubmit = async (data: any) => {
    setLoading(true);
    // console.log("data", data);
    const payload: Record<string, any> = {
      userId: driverVehicleEditdata?.driverId,
      trackerId: data.trackerId,
      assign: true
    };

    await driversService
      .assignDriverVehicle(payload)
      .then((response: any) => {
        if (response?.data?.status === "success") {
          getDriverData(driverVehicleEditdata?.driverId);
          //push(`/drivers`);
        } else {
          setErrorMessage(
            response?.data?.message
              ? response?.data?.message
              : "Sorry!, We have technical issue please try again later"
          );
        }
      })
      .catch(err => {
        if (err?.errors.length > 0) {
          err?.errors.forEach(
            ({field, message}: {field: any; message: string}) => {
              setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
    // if (items?.driverId) {
    // }
  };
  const reloadDriverData = () => {
    getDriverData(driverVehicleEditdata?.driverId);
  };

  return (
    <>
      <div className="w-full rounded-lg  border border-gray-200 p-3 shadow-md">
        {/* onSubmit={handleSubmit(onSubmit)} */}
        <div className="rouned-lg mb-2 flex flex-col justify-start border-b-2 border-gray-200 bg-white p-4">
          <h2 className="text-lg font-semibold">Vehicle Information</h2>
          <p className="text-sm text-gray-500">
            Please fill in the vehicle information of the driver.
          </p>
        </div>
        {vehiceDetails.fields.length > 0 ? (
          <>
            <AssignedVehicleView
              assignedVehicle={vehiceDetails}
              driverId={driverVehicleEditdata.driverId}
              title={"Assigned Vehicle"}
              key={"vehicleDetails"}
              reloadDriverData={reloadDriverData}
              // isShowDelete={false}
            />
          </>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="w-full px-5">
            {/* grid w-full grid-cols-1 gap-2 max-sm:grid-cols-1 */}
            <div className="flex items-center justify-between gap-2">
              {/* <Controller
                name="trackerId"
                control={control}
                render={({field}) => (
                  <NeoSelect
                    {...field}
                    label=""
                    id="trackerId"
                    placeholder="Please select vehicle"
                    // selectedKeys={[String(field.value)]} // 🔑 show selected value
                    defaultSelectedKeys={[driverVehicleEditdata?.trackerId]}
                    //onSelectionChange={(keys) => field.onChange(Number([...keys][0]))}
                    color={errors.trackerId ? "danger" : "default"}
                    isInvalid={!!errors.trackerId}
                    errorMessage={
                      errors.trackerId && `${errors.trackerId.message}`
                    }
                    {...register("trackerId")}
                  >
                    {vehicles?.map((e: any) => (
                      <SelectItem key={e.trackerId} value={e.trackerId}>
                        {e.trackerName}
                      </SelectItem>
                    ))}
                  </NeoSelect>
                )}
              /> */}
              <div className="flex w-full flex-col justify-center">
                <Select
                  name="trackerId"
                  options={vehicles || []}
                  getOptionLabel={e => e.trackerName}
                  getOptionValue={e => e.trackerId.toString()}
                  defaultValue={
                    vehicles.find(
                      v => v.trackerId === driverVehicleEditdata?.trackerId
                    ) || null
                  }
                  //defaultValue={[driverVehicleEditdata?.trackerId]}
                  onChange={selectedOption => {
                    setValue("trackerId", selectedOption?.trackerId);
                  }}
                  placeholder="Select Vehicle"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "40px",
                      borderWidth: "2px",
                      borderColor: "#d4d4d8",
                      borderRadius: "12px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      boxShadow: "none",
                      fontSize: "14px",
                      color: "#111827",
                      backgroundColor: "white",
                      "&:hover": {
                        borderColor: "#d4d4d8"
                      }
                    }),
                    placeholder: base => ({
                      ...base,
                      color: "#6b7280",
                      fontSize: "14px"
                    }),
                    indicatorSeparator: () => ({
                      display: "none"
                    }),
                    dropdownIndicator: base => ({
                      ...base,
                      color: "#6b7280",
                      paddingRight: "8px"
                    }),
                    // singleValue: base => ({
                    //   ...base,
                    //   color: "#111827"
                    // }),
                    menu: base => ({
                      ...base,
                      borderRadius: "10px",
                      zIndex: 50
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused ? "#e5e7eb" : "white",
                      color: "#111827",
                      padding: "10px 12px",
                      cursor: "pointer",
                      borderRadius: "8px",
                      margin: "2px 4px"
                    })
                  }}
                />
              </div>
              <div className="flex items-center justify-end p-4">
                <NeoButton
                  className="mx-2"
                  type="submit"
                  size="sm"
                  // disabled={isSubmitting}
                  isLoading={loading}
                  spinner={
                    <AiOutlineLoading
                      size="xs"
                      className="animate-spin h-6 w-6"
                    />
                  }
                  color="black"
                >
                  Assign Vehicle
                </NeoButton>
              </div>
            </div>
            {errorMessage ? <NeoError message={errorMessage}></NeoError> : null}

            {succssMessage ? (
              <NeoSuccess message={succssMessage}></NeoSuccess>
            ) : null}
          </form>
        )}
      </div>
    </>
  );
};
